import {
    FETCH_WORKOUT_TYPES_FETCHING,
    FETCH_WORKOUT_TYPES_SUCCESS,
    FETCH_WORKOUT_TYPES_FAIL,
    FETCH_WORKOUT_ALL_TYPES_FETCHING,
    FETCH_WORKOUT_ALL_TYPES_SUCCESS,
    FETCH_WORKOUT_ALL_TYPES_FAIL
} from '../../actions/ActionTypes.js';

import { parseWorkoutTypes } from 'utils/workout/WorkoutUtil.js';

const INITIAL_STATE = {
    workoutTypes: [],
    workoutTypesFetching: false,
    workoutTypesFetchFail: false,
    workoutAllTypes: {},
    workoutAllTypesFetching: false,
    workoutAllTypesFetchFail: false
};

const workoutTypesFetching = (state) => ({
    ...state,
    workoutTypesFetching: true,
    workoutTypesFetchFail: false
});

const workoutTypesFetchSuccess = (state, action) => {
    return {
        ...state,
        workoutTypes: parseWorkoutTypes(action.data, action.filteredWorkoutTypes),
        workoutTypesFetching: false,
        workoutTypesFetchFail: false
    };
};

const workoutTypesFetchFail = (state, action) => {
    return {
        ...state,
        workoutTypesFetching: false,
        workoutTypesFetchFail: true
    };
};

const workoutAllTypesFetching = (state) => ({
    ...state,
    workoutAllTypesFetching: true,
    workoutAllTypesFetchFail: false
});

const workoutAllTypesFetchSuccess = (state, action) => ({
    ...state,
    workoutAllTypes: action.data,
    workoutAllTypesFetching: false,
    workoutAllTypesFetchFail: false
});

const workoutAllTypesFetchFail = (state) => ({
    ...state,
    workoutAllTypesFetching: false,
    workoutAllTypesFetchFail: true
});

export const getWorkoutTypes = (state) => {
    return state.workoutTypes.workoutTypes;
};

export const isWorkoutTypesFetching = (state) => {
    return state.workoutTypes.workoutTypesFetching;
};

export const getWorkoutAllTypes = (state) => {
    return state.workoutTypes.workoutAllTypes;
};

export const isWorkoutAllTypesFetching = (state) => {
    return state.workoutTypes.workoutConditionTypesFetching;
};

const handlers = {
    [FETCH_WORKOUT_TYPES_FETCHING]: workoutTypesFetching,
    [FETCH_WORKOUT_TYPES_SUCCESS]: workoutTypesFetchSuccess,
    [FETCH_WORKOUT_TYPES_FAIL]: workoutTypesFetchFail,
    [FETCH_WORKOUT_ALL_TYPES_FETCHING]: workoutAllTypesFetching,
    [FETCH_WORKOUT_ALL_TYPES_SUCCESS]: workoutAllTypesFetchSuccess,
    [FETCH_WORKOUT_ALL_TYPES_FAIL]: workoutAllTypesFetchFail
};

export default function workoutTypes(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
